import { render, staticRenderFns } from "./maintenanceStandard.vue?vue&type=template&id=b16232c6&"
import script from "./maintenanceStandard.vue?vue&type=script&lang=js&"
export * from "./maintenanceStandard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports